<template>
  <Page>
    <div
      :class="$style['service']"
      class="container container--small">
      <div class="h-margin-bottom">
        <NuxtLink
          class="router-link-active"
          :no-prefetch="true"
          :to="{
            path: `/${$lang}/service`
          }">
          {{ $t('general/customer-support') }}
        </NuxtLink>
        &nbsp;/
        <h1
          v-if="questions?.length"
          :class="$style['service__header']"
          class="h-margin-bottom h-margin-top-s">
          {{ questions[0].subject }}
        </h1>
      </div>

      <List bordered>
        <ListItem
          v-for="(question, index) in questions"
          :key="index"
          :to="question.slug">
          {{ question.question }}
        </ListItem>
      </List>

      <h2
        :class="$style['service__sub-heading']"
        class="h-margin-bottom h-margin-top-xl">
        {{ $t('general/do-you-have-questions') }}
      </h2>
      <ServiceEmailTelephone class="h-margin-top" />
    </div>
  </Page>
</template>
<script setup>
import { formatCanonical, formatOpenGraph, formatMetaDescription } from '~/helpers/metadata'
import { hasSpecialChars } from '~/helpers/custom-validators'
const { $api } = useNuxtApp()
const route = useRoute()
const { getSubCategoryBySlug } = useNavigation()

if (hasSpecialChars(route.params.subject)) {
  throw createError({ statusCode: 404, statusMessage: 'invalid subject' })
}

const navigationId = getSubCategoryBySlug('service', route.params.subject)?.id || 18

const { data, error } = await useAsyncData(`service-${route.params.subject}`, async () => {
  const [navigation, questions] = await Promise.all([
    $api(`navigation/${navigationId}`),
    $api(`faqs/${route.params.subject}`)
  ])

  return { navigation, questions }
})

const navigation = computed(() => {
  return data.value.navigation
})

const questions = computed(() => {
  return data.value.questions
})

if (error.value) {
  showError({ statusCode: 404, statusMessage: error.value.message })
}

await useI18n(['faq', 'service'])

const metaData = unref(navigation.value).metaData

useHead({
  title: () => metaData.pageTitle,
  titleTemplate: '%s',
  link: [
    ...formatCanonical(metaData)
  ],
  meta: [
    ...formatOpenGraph(metaData.openGraph),
    formatMetaDescription(metaData)
  ],
  script: [
    {
      type: 'application/ld+json',
      innerHTML: metaData.schemaOrg
    }
  ]
})

</script>
<style lang="scss" module>
.service {
  &__sub-heading {
    font-family: var(--font-heading);
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-xl);
    line-height: 1;
  }

  @media (max-width: #{$breakpoint-mobile}) {
    &__sub-heading {
      font-size: var(--font-size-l);
    }
  }

  &__header {
    text-transform: capitalize;
  }
}
</style>
